<template>
    <div class="doc-section">
        <h1>Agregar Ubicación</h1>
        <p>
            Este proceso permite definir un punto geográfico específico mediante herramientas de dibujo en el mapa y el
            registro de coordenadas.
        </p>

        <plataformaNavegacion @cambio-plataforma="actualizarVista" />

        <div v-if="plataforma === 'web'" class="platform-content">
            <h2>Pasos para el Registro</h2>
            <p>Para registrar una nueva ubicación, haga clic sobre el botón <strong>Agregar ubicación</strong>; esto
                desplegará el formulario debajo del mapa:</p>


            <ol class="ul-contenedor step-list">
                <li>Para modificar la posición, puede interactuar con el mapa de dos formas:
                    <ul style="list-style: none; padding-left: 15px; margin-top: 5px;">
                        <li>a) Hacer clic sobre el botón <strong>Editar</strong> situado en el mapa para arrastrar el
                            marcador manualmente.</li>
                        <li>b) Modificar directamente los valores numéricos en los campos de <strong>Latitud</strong> o
                            <strong>Longitud</strong>.
                        </li>
                    </ul>
                </li>
                <li>Ingrese o corrija el <strong>Nombre del marcador</strong> si es necesario.</li>
                <li>Latitud, se muestra el valor de la coordenada del marcador colocado sobre el mapa. Este campo al ser
                    modificado el marcador se actualizará a la posición ingresada.</li>
                <li>Longitud, se muestra el valor de la coordenada del marcador colocado sobre el mapa. Este campo al
                    ser
                    modificado el marcador se actualizará a la posición ingresada.</li>
                <li>Hacer clic en el botón <strong>Cancelar</strong> si desea descartar los cambios y regresar a la
                    vista
                    anterior.</li>
                <li>Hacer clic sobre el botón <strong>Guardar ubicación</strong> para aplicar los cambios. El sistema
                    mostrará una notificación indicando que la actualización fue exitosa.</li>
            </ol>

            <div class="card">
                <h3><strong>Confirmación del Sistema</strong></h3>
                <p>
                    Al finalizar el guardado, el sistema emitirá una notificación visual confirmando que la operación se
                    completó correctamente.
                </p>
            </div>

            <h3>Guía Visual de Creación</h3>
            <CarruselAciqui :items="imagenesAgregarUbicacion" />
        </div>

        <div v-if="plataforma === 'moviles'" class="platform-content">
            <h2>Pasos para el Registro</h2>
            <p>Para registrar una nueva ubicación, haga clic sobre el botón <strong>Agregar ubicación</strong>; esto
                desplegará el formulario debajo del mapa</p>

                <CarruselAciqui :items="[imagenesAgregarUbicacionMoviles[0]]" />


            <ol class="ul-contenedor step-list">
                <li>Para modificar la posición de la ubicación, puede realizarlo de dos formas:
                    <ul style="list-style: none; padding-left: 15px; margin-top: 5px;">
                        <li>a) Hacer clic sobre el botón <strong>Marker</strong> situado en el mapa para arrastrar el
                            marcador manualmente.
                        <CarruselAciqui :items="[imagenesAgregarUbicacionMoviles[2]]" />
                        </li>
                        <li>b) Modificar directamente los valores numéricos en los campos de <strong>Latitud</strong> o
                            <strong>Longitud</strong>.
                            <CarruselAciqui :items="[imagenesAgregarUbicacionMoviles[1]]" />
                        </li>
                    </ul>
                </li>
                <li>Ingrese el <strong>Nombre del marcador</strong> si es necesario.</li>
                <li>Latitud, se muestra el valor de la coordenada del marcador colocado sobre el mapa. Este campo al ser
                    modificado el marcador se actualizará a la posición ingresada.</li>
                <li>Longitud, se muestra el valor de la coordenada del marcador colocado sobre el mapa. Este campo al
                    ser
                    modificado el marcador se actualizará a la posición ingresada.</li>
                <li>Hacer clic en el botón <strong>Cancelar</strong> si desea descartar los cambios y regresar a la
                    vista
                    anterior.</li>
                <li>Hacer clic sobre el botón <strong>Guardar ubicación</strong> para aplicar los cambios. El sistema
                    mostrará una notificación indicando que la actualización fue exitosa.</li>
            </ol>
            <CarruselAciqui :items="[imagenesAgregarUbicacionMoviles[3]]" />

            <div class="card">
                <h3><strong>Confirmación del Sistema</strong></h3>
                <p>
                    Al finalizar el guardado, el sistema emitirá una notificación visual confirmando que la operación se
                    completó correctamente.
                </p>
            </div>

            <CarruselAciqui :items="[imagenesAgregarUbicacion[2]]" />
        </div>


    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'AgregarUbicacion',
    components: { CarruselAciqui, plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenesAgregarUbicacion: [
            {
                nombre: "Opciones de Creación",
                url: "img/ubicaciones/opcionesCreacionUbicacion.png",
                descripcion: "Herramientas de dibujo sobre el mapa."
            },
            {
                nombre: "Formulario de datos para el alta del dispositivo",
                url: "img/ubicaciones/formularioaltaUbicacion.png",
                descripcion: "Campos de nombre y coordenadas."
            },
            {
                nombre: "Notificación de Éxito",
                url: "img/ubicaciones/exitoAltaUbicacion.png",
                descripcion: "Mensaje de confirmación tras guardar."
            }
        ],

        imagenesAgregarUbicacionMoviles: [
            {
                nombre: "",
                url: "img/ubicaciones/moviles/btn_agregar_ubicacion.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/ubicaciones/moviles/formulario_agregar_ubicacion.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/ubicaciones/moviles/btn_agregar_marker_ubicacion.png",
                descripcion: ""
            },{
                nombre: "",
                url: "img/ubicaciones/moviles/llenado_formulario.png",
                descripcion: ""
            }
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>